import e from "cors";
import { element } from "prop-types";
import React, { useEffect, useState } from "react";
// import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const PopupPwdConfirm = props => {
    const location = useLocation();
    const [headerClass, setHeaderClass] = useState("sub");
    const [mobileBtn, setMobileBtn] = useState(true);
    const [pwd, setPwd] = useState("");

    // 메뉴
    useEffect(() => {}, []);

    return (
        <div className={"pop_secret_view" + (props.show ? " on" : "")}>
            <button type="button" className="btn_close" onClick={props.onClose}>
                닫기
            </button>
            <h2>
                <span className="icons-lock"></span>
                파트너사 보안문서 보기
            </h2>
            <p className="txt">
                이 페이지는 파트너사의 안전 보건자료 <br />
                <b>제공 및 열람</b>을 위한 공간입니다.
                {/* <br /> 관리자는 확인버튼만 누르시면 됩니다. */}
            </p>
            <div className="password-write">
                <label htmlFor="pwd">비밀번호</label>
                <input type="password" id="pwd" placeholder="비밀번호를 입력하세요" value={pwd} onChange={e => setPwd(e.target.value)} />
            </div>
            <div className="btns">
                <button type="button" className="btn_nor gray-line" onClick={props.onClose}>
                    목록
                </button>
                <button
                    type="button"
                    className="btn_nor red"
                    onClick={() => {
                        props.onConfirm(pwd);
                    }}
                >
                    확인
                </button>
            </div>
        </div>
    );
};

export default PopupPwdConfirm;
